// in dev, this makes Vite inject its client as this module's first dependency,
// so that global constant replacements are installed before any other module
// (including user hooks) evaluates. In build it's inert.
import.meta.hot;




export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26')
];

export const server_loads = [];

export const dictionary = {
		"/": [2],
		"/admin": [3],
		"/admin/audio-selection-letters": [5],
		"/admin/audio-selection": [4],
		"/admin/cards-management": [6],
		"/admin/login": [7],
		"/admin/similarites-phonetiques": [8],
		"/admin/test-alignement": [9],
		"/admin/users": [10],
		"/admin/words-management": [11],
		"/apprendre-a-lire": [12],
		"/apprendre-a-lire/alphabet": [13],
		"/apprendre-a-lire/anagrammes": [14],
		"/apprendre-a-lire/ecrire-les-mots": [15],
		"/apprendre-a-lire/grille-mots": [16],
		"/apprendre-a-lire/labyrinthe-mots": [17],
		"/apprendre-a-lire/memory-texte-image": [18],
		"/apprendre-a-lire/orthographe": [19],
		"/apprendre-a-lire/tables": [20],
		"/auth": [21],
		"/classes": [22],
		"/historique": [23],
		"/mes-listes": [24],
		"/mes-listes/[id]": [25],
		"/profil": [26]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
	
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';

export const get_error_template = () => import('../shared/error-template.js').then(m => m.default);